import { Tag } from '@zendeskgarden/react-tags'
import type { ZenTagProps } from './interface'

export function ZenTag({ label, hue, avatar, onClose }: ZenTagProps) {
  return (
    <Tag hue={hue}>
      {avatar && <Tag.Avatar>{avatar}</Tag.Avatar>}
      {label}
      {onClose && <Tag.Close onClick={onClose} />}
    </Tag>
  )
}
